export default __webpack_public_path__ + "assets/images/discord-826f6bfec69b840f877449583bcc766d.svg";